<template>
  <div v-if="!editMode" class="policy-terms--mobile hide-for-large">
    <a id="terms-button" class="button secondary align-center" @click="goToTerms">Se vilkår</a>
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'MobileTermsButton',
  computed: {
    editMode() {
      return this.$store.state.policy.editMode;
    }
  },
  methods: {
    goToTerms() {
      const elm = $('#policy-terms-and-conditions');
      Utility.scrollToElem(elm, 90);
    }
  }
};
</script>
